export const categoriasPrisma = {
    deporte: {
        name: 'Deporte',
        englishName: 'Sports',
        color: '#80DEEA', // Cian 200 (suave) - Color de texto/acento
        backgroundColor: '#80DEEA', // Color de fondo para chips
        subcategorias: ['deporte'],
    },
    salseo: {
        name: 'Salseo',
        englishName: 'Hot Topics',
        color: '#EF9A9A', // Rojo 200
        backgroundColor: '#EF9A9A',
        subcategorias: ['politica', 'social'],
    },
    pantallazos: {
        name: 'Pantallazos',
        englishName: 'On Screens',
        color: '#90CAF9', // Azul 200
        backgroundColor: '#90CAF9',
        subcategorias: ['tecnologia', 'entretenimiento'],
    },
    'estilo-de-vida': {
        name: 'Estilo de Vida',
        englishName: 'Lifestyle',
        color: '#F48FB1', // Rosa 200
        backgroundColor: '#F48FB1',
        subcategorias: ['salud', 'educacion', 'cultura'],
    },
    economia: {
        name: 'Economía',
        englishName: 'Business & Finance',
        color: '#A5D6A7', // Verde 200
        backgroundColor: '#A5D6A7',
        subcategorias: ['economia'],
    },
    curiosidades: {
        name: 'Curiosidades',
        englishName: 'Science & Nature',
        color: '#CE93D8', // Púrpura 200
        backgroundColor: '#CE93D8',
        subcategorias: ['ciencia', 'medio-ambiente'],
    },
    entretenimiento: {
        name: 'Entretenimiento',
        englishName: 'Entertainment',
        color: '#FFCC80', // Naranja 200
        backgroundColor: '#FFCC80',
        subcategorias: ['entretenimiento'],
    },
};

export const categoriasForNavigationBar = () => {
    return Object.entries(categoriasPrisma).map(([id, config]) => ({
        id,
        ...config,
    }));
};
